import {ForwardRefExoticComponent, ReactElement, ReactNode, SVGProps} from "react";
import "./PageTitle.scss";

export interface PageTitleProps {
    title: string;
    icon?: ReactElement<
        ForwardRefExoticComponent<
            Omit<SVGProps<SVGSVGElement>, string | number | symbol>
        >
    >;
    children?: ReactNode;
}

/**
 * Component for showing a page title
 */
export const PageTitle = ({ title, icon, children }: PageTitleProps) => {
    return (
        <div className="page-title-bar">
            <div className="d-flex align-items-center gap-2">
                {icon !== undefined && (
                    <span className="page-title-icon">{icon}</span>
                )}
                <h1 className="page-title-text m-0">{title}</h1>
            </div>
            {children}
        </div>
    );
};
